import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";
import {
  formatoMonto,
  formatMoneda,
  seleccionarCampo,
  nmes,
  validaMonto,
} from "../../util/varios";
import { suma, calculoMontoPagar } from "../../util/OperacionesDeclaracion";
import { Table, TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import TableContainer from "@material-ui/core/TableContainer";
import axios from "axios";
import moment from "moment";

const headCells = [
  {
    id: "codigo",
    label: "CODIGO",
    width: "80px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "rgb(23, 147, 221)",
  },
  {
    id: "descripcion",
    label: "DESCRIPCION DE LA ACTIVIDAD",
    width: "600px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "rgb(23, 147, 221)",
  },
  {
    id: "alicuota",
    label: "ALICUOTA(%)",
    width: "150px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "rgb(23, 147, 221)",
  },
  {
    id: "montode",
    label: "MONTO A DECLARAR",
    width: "150px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "rgb(23, 147, 221)",
  },
  {
    id: "montopa",
    label: "MONTO A PAGAR",
    width: "150px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "rgb(23, 147, 221)",
  },
];

export const TabClaseProducDeclara = (props) => {
  /*  variables de estados */

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [contar, setContar] = useState(0);
  const [contar2, setContar2] = useState(0);
  const [tecla, setTecla] = useState();
  const [indice, setIndice] = useState(0);

  const [operacion, setOperacion] = useState(0);

  const txtTotalDeclarado = useRef();
  const txtTotalPagar = useRef();
  const txtFechaDeclaracion = useRef();

  const txtDeclaradoRef = useRef([]);
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const [colocaFocus, setColocaFocus] = useState(false);
  const [datoUT, setDatoUT] = useState([]);
  const [records, setRecords] = useState([]);

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const [montos, setMontos] = useState({
    impuesto: "0,00",
    intereses: "0,00",
    recargos: "0,00",
    retenciones: "0,00",
    credito: "0,00",
    acredit: "0,00",
    multa: "0,00",
  });

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    //setEspiritu(obj.espiritu);
    if (props.operacion) {
      setOperacion(props.operacion);
    }
  }, [props.operacion]);

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const selectUT = (idagente, anio, mes, tipo, fecha, espiritu, totdeuda) => {
    let endpoint = `${op.conexion}/api/produccion/valorutproduccion?idagente=${idagente}&anio=${anio}&mes=${mes}&tipo=${tipo}&fecha=${fecha}&espiritu=${espiritu}&totdeuda=${totdeuda}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setDatoUT(response.data);
          let data = [...records];
          var resu = [];
          resu = calculoMontoPagar(
            records,
            response.data,
            props.anio,
            props.tipodecla,
            props.config.calculaminimo
          );
          let totDec = parseFloat(0.0);
          let totPag = parseFloat(0.0);
          for (let i = 0; i < resu.length; i++) {
            for (let x = 0; x < resu[i].activi.length; x++) {
              data[x].montoapagar = resu[i].activi[x].montoapagar;
              totDec += parseFloat(
                data[x].montodeclarado.replace(/\./g, "").replace(",", ".")
              );
              totPag += parseFloat(
                data[x].montoapagar.replace(/\./g, "").replace(",", ".")
              );
            }
          }
          if (response.data.mensaje !== "") {
            setTitulo("Información");
            setMsg(response.data.mensaje);
            setMostrar(true);
          }
          setRecords(data);
          txtTotalDeclarado.current.value = formatMoneda(
            totDec.toFixed(2).toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtTotalPagar.current.value = formatMoneda(
            totPag.toFixed(2).toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const handleInputChange = (index) => (event) => {
    //event.preventDefault();
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
      let data = [...records];
      let totDec = parseFloat(0.0);
      let totPag = parseFloat(0.0);
      //data[index].montodeclarado = event.target.value;
      //data[index].montodeclarado = formatoMonto(event.target.value).replace(/\./g, '').replace(',', '.');
      data[index].montodeclarado = formatoMonto(event.target.value);
      data[index].montoapagar = "0,00";

      setRecords(data);
      /*selectUT({
                variables: {
                    fecha: txtFechaDeclaracion.current.value
                }
            });*/

      //if (datoUT.length > 0) {
      if (datoUT) {
        var resu = [];
        //resu = suma(records, props.anio, props.mes, props.datoCalculo, props.tipodecla, espiritu);
        resu = calculoMontoPagar(
          records,
          datoUT,
          props.anio,
          props.tipodecla,
          props.config.calculaminimo
        );
        if (resu.length === 0) {
          setMostrar(true);
          //return document.location.href = "./home";
        }
        for (let i = 0; i < resu.length; i++) {
          setMontos({
            impuesto: resu[i].impuesto,
            intereses: resu[i].intereses,
            recargos: resu[i].recargos,
            retenciones: resu[i].retenciones,
            credito: resu[i].credito,
            acredit: resu[i].acredit,
            multa: resu[i].multa,
          });

          for (let x = 0; x < resu[i].activi.length; x++) {
            data[x].montoapagar = resu[i].activi[x].montoapagar;
            totDec += parseFloat(
              data[x].montodeclarado.replace(/\./g, "").replace(",", ".")
            );
            totPag += parseFloat(
              data[x].montoapagar.replace(/\./g, "").replace(",", ".")
            );
          }
          txtTotalDeclarado.current.value = formatMoneda(
            totDec.toFixed(2).toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
          txtTotalPagar.current.value = formatMoneda(
            totPag.toFixed(2).toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          );
        }

        setRecords(data);
        //handler(index);
        if (event.which === 13) {
          if (index + 1 === txtDeclaradoRef.current.length) {
            //txtDeclaradoRef.current[index].focus();
            setColocaFocus(true);
          } else {
            txtDeclaradoRef.current[index + 1].focus();
            setColocaFocus(false);
          }
        } else {
          setColocaFocus(false);
        }
        event.target.value = formatoMonto(event.target.value);
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const handleInputFechaChange = (event) => {
    //setActiveIndex(1);
    if (event.which === 13 || typeof event.which === "undefined") {
      selectUT(
        parseInt(props.idagente, 10),
        props.anio,
        props.nmes,
        props.tipodecla,
        txtFechaDeclaracion.current.value === ""
          ? fechaSistema
          : txtFechaDeclaracion.current.value,
        espiritu,
        props.totdeuda
      );
      /*selectUT({
                variables: {
                    idagen: parseInt(props.idagente, 10),
                    anio: props.anio,
                    mes: props.nmes,
                    tipo: props.tipodecla,
                    fecha: txtFechaDeclaracion.current.value,
                    espiritu: espiritu,
                    totdeuda: props.totdeuda
                }
            });*/
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const onChangeValidar = () => {
    var sigue = true;
    if (txtFechaDeclaracion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Debe Introducir la Fecha de Declaración",
        icono: "informacion",
      });
      sigue = false;
      txtFechaDeclaracion.current.focus();
    }
    if (sigue) {
      var axc = [];
      for (let i = 0; i < records.length; i++) {
        axc.push({
          alicuota: records[i].alicuota,
          codigoclaseproduccion: records[i].codigoclaseproduccion,
          descripcion: records[i].descripcion,
          idclaseproduccion: records[i].idclaseproduccion,
          minimo: records[i].minimo,
          montodeclarado: records[i].montodeclarado
            .replace(/\./g, "")
            .replace(",", "."),
          montoapagar: records[i].montoapagar
            .replace(/\./g, "")
            .replace(",", "."),
          fechadeclaracion: txtFechaDeclaracion.current.value,
        });
      }
      props.onHideAcepta(axc);
    }
  };

  const cancelar = () => {
    props.onHideCancela();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        //txtFechaDeclaracion.current.value = fechaSistema;
        if (props.tabaclaseprodxagen && txtTotalDeclarado.current) {
          setRecords(props.tabaclaseprodxagen);
          setDatoUT(props.datoCalculo);
          var resu = [];
          //resu = suma(props.tabaclaseprodxagen, props.anio, props.mes, props.datoCalculo, props.tipodecla, espiritu);
          resu = calculoMontoPagar(
            props.tabaclaseprodxagen,
            props.datoCalculo,
            props.anio,
            props.tipodecla,
            props.config.calculaminimo
          );
          let totDec = parseFloat(0.0);
          let totPag = parseFloat(0.0);
          for (let i = 0; i < resu.length; i++) {
            for (let x = 0; x < resu[i].activi.length; x++) {
              totDec += parseFloat(
                resu[i].activi[x].montodeclarado
                  .replace(/\./g, "")
                  .replace(",", ".")
              );
              totPag += parseFloat(
                resu[i].activi[x].montoapagar
                  .replace(/\./g, "")
                  .replace(",", ".")
              );
            }
            txtTotalDeclarado.current.value = formatMoneda(
              totDec.toFixed(2).toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
            txtTotalPagar.current.value = formatMoneda(
              totPag.toFixed(2).toString().replace(",", "").replace(".", ","),
              ",",
              ".",
              2
            );
          }
        }
      }}
    >
      <Modal.Header className="azulGradiant2">
        <Modal.Title style={{ color: "#fff" }}>
          {operacion === 1
            ? "Agregar Actividad."
            : operacion === 2
            ? "Editar Actividad."
            : operacion === 3
            ? "Eliminar Actividad."
            : "Consultar Actividad."}
        </Modal.Title>
        {/*<button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>*/}
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div
          className="row col-md-12"
          style={{ marginLeft: 0, marginRight: 0, marginBottom: "10px" }}
        >
          <div className="col-md-9">
            <label htmlFor="inputRitm" style={{ fontSize: "16px" }}>
              {"DECLARACION JURADA " +
                (props.tipodecla === "3"
                  ? " 1ERA. QUINCENA "
                  : props.tipodecla === "4"
                  ? " 2DA. QUINCENA "
                  : "") +
                props.mes +
                "-" +
                props.anio}{" "}
            </label>
          </div>
          <div className="input-group input-group-sm col-sm-3">
            <label className="input-group-text" id="inputGroup-sizing-sm">
              Fecha:
            </label>
            <input
              ref={txtFechaDeclaracion}
              type="date"
              className="form-control form-control-sm"
              id="inputFechaNac"
              max={moment(fechaSistema).format("YYYY-MM-DD")}
              defaultValue={moment(fechaSistema).format("YYYY-MM-DD")}
              onKeyUp={handleInputFechaChange}
              onBlur={handleInputFechaChange}
            />
          </div>
        </div>

        <div style={{ backgroundColor: "#ffffff", padding: "0" }}>
          <TableContainer>
            <Table
              stickyHeader
              className="table table-bordered table-striped"
              style={{ border: "1px solid #b1d3f4" }}
            >
              <TblHead />
              <TableBody>
                {records &&
                  records.map((post1, index) =>
                    post1.idclaseproduccion === "" ? (
                      ""
                    ) : (
                      <TableRow key={post1.idclaseproduccion}>
                        <TableCell
                          style={{ padding: "3px", textAlign: "center" }}
                        >
                          {post1.codigoclaseproduccion}
                        </TableCell>
                        <TableCell
                          style={{
                            padding: "3px",
                            width: "270px",
                            textAlign: "center",
                          }}
                        >
                          {post1.descripcion}
                        </TableCell>
                        <TableCell style={{ padding: "3px", width: "80px" }}>
                          <input
                            type="text"
                            name={"ali" + post1.idclaseproduccion}
                            defaultValue={formatMoneda(
                              post1.alicuota.replace(",", "").replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                            style={{ textAlign: "right", fontSize: "11" }}
                            disabled
                            className="form-control form-control-sm"
                          />
                        </TableCell>
                        <TableCell style={{ padding: "3px" }}>
                          <input
                            ref={(el) => (txtDeclaradoRef.current[index] = el)}
                            type="text"
                            name={post1.idclaseproduccion}
                            defaultValue={formatMoneda(
                              post1.montodeclarado
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                            style={{ textAlign: "right", fontSize: "11" }}
                            onFocus={seleccionarCampo}
                            onKeyUp={handleInputChange(index)}
                            onBlur={handleInputChange(index)}
                            className="form-control form-control-sm"
                          />
                        </TableCell>
                        <TableCell style={{ padding: "3px" }}>
                          <input
                            type="text"
                            name={"total" + post1.idclaseproduccion}
                            value={post1.montoapagar}
                            style={{ textAlign: "right", fontSize: "11" }}
                            disabled
                            className="form-control form-control-sm"
                          />
                        </TableCell>
                      </TableRow>
                    )
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div
          className="row col-md-12"
          style={{
            marginLeft: 0,
            marginRight: 0,
            marginTop: "10px",
            marginBottom: "10px",
            paddingRight: 0,
          }}
        >
          <div className="col-md-6" style={{ textAlign: "end" }}>
            Totales:
          </div>
          <div
            className="row col-md-6"
            style={{ marginRight: 0, paddingRight: 0 }}
          >
            <div className="col-md-6">
              <input
                type="text"
                readOnly
                ref={txtTotalDeclarado}
                style={{ textAlign: "right" }}
                className="form-control form-control-sm"
                id="inputTotalDeclarado"
                defaultValue="0,00"
              />
            </div>
            <div
              className="col-md-6"
              style={{ marginRight: 0, paddingRight: 0 }}
            >
              <input
                type="text"
                readOnly
                ref={txtTotalPagar}
                style={{ textAlign: "right" }}
                className="form-control form-control-sm"
                id="inputTotalPagar"
                defaultValue="0,00"
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          onClick={onChangeValidar}
          className="btn btn-sm rounded-pill btn-success col-md-2"
        >
          <i className="fas fa-check-circle"> Aceptar</i>
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm rounded-pill btn-secondary col-md-2"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/impuestoprodu/modalTabClaseProducDeclara.js